const { INTERESTS, VALUES, WORKPLACE, PERSONALITY, PURPOSE_SURVEY } = require('./assessments');

const psychGroups = {
  values: [16, 21, 18, 19, 20, 17],

  interests: [22, 23, 24, 25, 26, 27],

  workplace: [2, 3, 4, 5, 6, 7, 8],

  personality: [
    14, // this score is reversed
    11,
    12,
    13,
    15,
    29, // Humility only in personality hexaco
  ],
};

const allPsychGroupsByAssessmentId = {
  [INTERESTS]: psychGroups.interests,
  [VALUES]: psychGroups.values,
  [WORKPLACE]: psychGroups.workplace,
  [PERSONALITY]: psychGroups.personality,
  [PURPOSE_SURVEY]: [30, 31, 32],
};

module.exports = {
  psychGroups,
  allPsychGroupsByAssessmentId,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/psych-groups.js
// module id = 417
// module chunks = 58